import { TableCell, TableRow } from "../../../../../design/table";
import { ChildSupportPayment } from "../../../../../models/ChildSupportPayment";
import moment from "moment";
import ChildSupportPaymentStatusBadge from "../../../../../components/ChildSupportPaymentStatusBadge";

const ChildSupportPaymentListItem: React.FC<{
  childSupportPayment: ChildSupportPayment;
}> = ({ childSupportPayment }) => {
  return (
    <TableRow href={`/child-support-payment/${childSupportPayment._id}`}>
      <TableCell>
        {moment(childSupportPayment.date).format("MMMM D, YYYY")}
      </TableCell>
      <TableCell>
        <ChildSupportPaymentStatusBadge status={childSupportPayment.status} />
      </TableCell>
      <TableCell>
        {new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(childSupportPayment.amount)}
      </TableCell>
    </TableRow>
  );
};

export default ChildSupportPaymentListItem;
